import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.colors.teal,
    color: theme.palette.colors.white,
  },
  lightBackground: {
    backgroundColor: theme.palette.colors.lightTeal,
  },
  sizeL: {
    width: 48,
    height: 48,
    fontSize: 18,
  },
  sizeM: {
    width: 40,
    height: 40,
    fontSize: 16,
  },
  sizeS: {
    width: 32,
    height: 32,
    fontSize: 16,
  },
  sizeXs: {
    width: 24,
    height: 24,
    fontSize: 12,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Avatar/useStyles.js